module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/Ray-Ban-aa587eaf35944e9639a2b4b90539be4c.png";